/** Вариант ответа при создании опроса (REST `POST /poll`). */
export type CreatePollOption = {
  value: string;
  isRightAnswer?: boolean;
  dsc?: string;
};

/** Тело запроса создания опроса. */
export type CreatePollPayload = {
  subject: string;
  isAnonymous: boolean;
  multipleAnswers: boolean;
  isQuiz: boolean;
  options: CreatePollOption[];
};

/** Ответ `POST /poll`. */
export type PollCreateResponse = {
  id: string;
  subject: string;
  isAnonymous: boolean;
  multipleAnswers: boolean;
  isQuiz: boolean;
  options?: CreatePollOption[];
  rObject?: string;
};

/**
 * Превью варианта ответа в сообщении чата.
 */
export type PollOption = {
  /** ID варианта */
  i: string;
  /** Текст варианта ответа */
  v: string;
  /** Процент голосов за вариант (целое) */
  pv: number;
  /** Порядок отображения */
  ord: number;
  /** Выбран текущим пользователем */
  c?: boolean;
  /** Правильный ответ -- после завершения опроса */
  r?: boolean;
  /** Пояснение к правильному ответу -- после завершения опроса */
  d?: string | null;
};

/** Автор опроса в превью сообщения. */
export type PollOwnerPreview = {
  /** ID пользователя */
  i: string;
};

/**
 * Проголосовавший пользователь (`GET /poll`, `GET /answer-users`).
 */
export type PollResultsVoter = {
  id: string;
  fullName: string;
  image?: { id: string; path: string } | null;
};

/**
 * Превью опроса в ленте / WS.
 * `aa`: приходит только голосовавшему пользователю
 */
export type PollInMessage = {
  /** ID опроса */
  i: string;
  /** Тема (вопрос) опроса */
  s?: string;
  /** Список вариантов ответа */
  oo: PollOption[];
  /** ID вариантов, выбранных текущим пользователем */
  aa?: PollOption['i'][];
  /** Опрос активен */
  a?: boolean;
  /** Анонимный опрос */
  an?: boolean;
  /** Общее число проголосовавших. Может отсутствовать в старых сообщениях / до первого голоса. */
  cv?: number;
  /** Мультивыбор */
  m?: boolean;
  /** Режим викторины */
  q?: boolean;
  /** Сведения об авторе опроса */
  o?: PollOwnerPreview;
};

/** Вариант ответа в ответе `GET /poll` */
export type PollResultsOption = {
  id: string;
  value: string;
  isRightAnswer: boolean;
  percentVote: number;
  cntVote: number;
  ord: number;
  dsc: string | null;
  users: PollResultsVoter[] | null;
};

/** Детали завершённого опроса — `GET /poll/:id` (только для автора). */
export type PollResultsDetails = {
  id: string;
  subject: string;
  isAnonymous: boolean;
  multipleAnswers: boolean;
  isQuiz: boolean;
  cStatus: boolean;
  cntVote: number;
  options: PollResultsOption[];
};

export type SubmitPollAnswerPayload = {
  pollId: string;
  optionIds: string[];
};

/** Вариант в ответе `PUT /poll/:id/answer` и `POST /poll/:id/stop` */
export type PollStatsOption = {
  i: string;
  pv: number;
  /** Отдается после stop викторины */
  r?: boolean;
  /** Отдается после stop викторины */
  d?: string | null;
};

/** Тело ответа `PUT /poll/:id/answer` — обновлённые stats без `aa` */
export type PollVoteStatsResponse = {
  cv: number;
  oo: PollStatsOption[];
};

/** Первый успешный stop; повторный вызов stop → `null` */
export type PollStopStatsResponse = PollVoteStatsResponse & {
  i: string;
};

export type GetPollAnswerUsersPayload = {
  pollId: string;
  optionId: string;
  limit?: number;
  page?: number;
};

export type PollAnswerUsersState = {
  error: string | null;
  hasMore: boolean;
  items: PollResultsVoter[];
  loading: boolean;
  noMoreByOptionKey: Record<string, boolean>;
  optionId: string | null;
  page: number;
  pollId: string | null;
};

export const POLL_PREVIEW_VOTERS_COUNT = 2;

export const POLL_ANSWER_USERS_PAGE_SIZE = 10;

export const initialPollAnswerUsersState = (): PollAnswerUsersState => ({
  error: null,
  hasMore: false,
  items: [],
  loading: false,
  noMoreByOptionKey: {},
  optionId: null,
  page: 0,
  pollId: null,
});
